import fetch from '@/config/fetch';
import fetchNew from '@/config/fetchNew';

/**
 * 委托商费用管理
 */
export const consignorOtherList = data => fetch('/platform/price/loadUnload/pageList', data, 'GET');
// 新增
export const addConsignorOther = data => fetch('/platform/price/loadUnload/add', data, 'POST');
// 修改
export const reviseConsignorOther = data => fetch('/platform/price/loadUnload/update', data, 'POST');
//查询车型
export const getCarSerieList = data => fetch('/platform/car/brand/getCarSerieList', data, 'GET');
// 详情
export const getCarSerDetail = data => fetch(`/platform/price/loadUnload/detail/${data}`, {}, 'GET');
// 启用/停用
export const changeEnableDisable = data => fetch('/platform/price/loadUnload/updateStatus', data, 'POST');
//  删除
export const deleteConsignorOther = data => fetch(`/platform/price/loadUnload/delete/${data}`, {}, 'POST');

//港口其费用新增
export const supplierPortOtheradd = data => fetch('/platform/price/supplierPortOther/add', data, 'POST');
//港口其费用修改
export const supplierPortOtherupdate = data => fetch('/platform/price/supplierPortOther/update', data, 'POST');
//港口其费用详情
export const supplierPortOtherdetail = id => fetch(`/platform/price/supplierPortOther/detail/${id}`, {}, 'GET');

//查询车型
export const supplierPortOtherpageList = data => fetch('/platform/price/supplierPortOther/pageList', data, 'GET');

/**
 * 港口作业费拦截
 */
export const portWorkList = data => fetch('/platform/price/portIntercept/pageList', data, 'GET');
// 新增
export const portWorkAdd = data => fetch('/platform/price/portIntercept/add', data, 'POST');
// 修改
export const portWorkRevise = data => fetch('/platform/price/portIntercept/update', data, 'POST');
// 详情
export const portWorkDetail = data => fetch(`/platform/price/portIntercept/detail/${data}`, {}, 'GET');
//港口其费用修改
export const supplierPortOtherdelete = id => fetch(`/platform/price/supplierPortOther/delete/${id}`, {}, 'POST');
//港口其费用修改
export const supplierPortOtherupdateStatus = data => fetch('/platform/price/supplierPortOther/updateStatus', data, 'POST');

// 启用/停用
export const portWorkEnable = data => fetch('/platform/price/portIntercept/updateStatus', data, 'POST');
//  删除
export const portWorkDelete = data => fetch(`/platform/price/portIntercept/delete/${data}`, {}, 'GET');

/**
 * 港口堆存费价格管理
 */
// 分页查询
export const stockpiledList = data => fetch('/platform/price/port/stockpile/pageList', data, 'GET');
// 详情
export const detailsList = id => fetch(`/platform/price/port/stockpile/detail/${id}`, {}, 'GET');
// 新增
export const addStockpiled = data => fetch('/platform/price/port/stockpile/add', data, 'POST');
// 修改
export const reviseStockpiled = data => fetch('/platform/price/port/stockpile/update', data, 'POST');
// 启用
export const enableStockpiled = id => fetch(`/platform/price/port/stockpile/enableDisable/${id}`, {}, 'GET');
// 停用
export const disableStockpiled = data => fetch('/platform/price/consignorOther/pageList', data, 'GET');
// 删除
export const deleteStockpiled = id => fetch(`/platform/price/port/stockpile/delete/${id}`, {}, 'GET');

/**
 * 港口价格管理
 */
//分页查询
export const portConfigureInforList = data => fetch('/platform/price/supplierPort/pageList', data, 'GET');
//添加
export const addPortConfigureInfo = data => fetch('/platform/price/supplierPort/addPricePort', data, 'POST');
//修改
export const revisePortConfigure = data => fetch('/platform/price/supplierPort/updatePricePort', data, 'POST');
//删除
export const deletePortConfigure = data => fetch(`/platform/price/supplierPort/deletePricePort/${data}`, {}, 'GET');
//启用/停用
export const enablePortConfigure = data => fetch('/platform/price/supplierPort/updateStatus', data, 'POST');
// 详情
export const portConfigureDetail = data => fetch(`/platform/price/supplierPort/detail/${data}`, {}, 'GET');

/**
 * 仓库价格管理
 */
export const storehouseInfoList = data => fetch('/platform/storehouse/info/storehouseInfoList', data, 'GET');

export const addStorehouseInfo = data => fetch('/platform/storehouse/info/addStorehouseInfo', data, 'POST');

/**
 * 提车费管理
 */
//分页查询
export const consignorHandoverList = data => fetch('/platform/price/consignorHandover/pageList', data, 'GET');

// 新增
export const addConsignorHandover = data => fetch('/platform/price/consignorHandover/add', data, 'POST');
// 修改
export const reviseConsignorHandover = data => fetch('/platform/price/consignorHandover/update', data, 'POST');
// 删除
export const deleteConsignorHandover = id => fetch(`/platform/price/consignorHandover/delete/${id}`, {}, 'POST');
//启用,停用
export const updateStatus = data => fetch('/platform/price/consignorHandover/updateStatus', data, 'POST');

export const customerInfoSelectList = data => fetch('/platform/sys/customerInfo/selectList', data, 'POST');

export const getTypeInfo = id => fetch(`/platform/vehicle-deploy-car-cv/getTypeInfo/${id}`, {}, 'GET');
// 详情
export const consignorDetail = data => fetch(`/platform/price/consignorHandover/detail/${data}`, {}, 'GET');
/**
 * 收入线路价格设置
 *
 */
// 收入线路价格设置分页查询
export const lineConsignorLineList = data => fetch('/platform/price/consignorLine/pageList', data, 'GET');

export const lineConfigSelectOpt = data => fetch('/platform/sys/lineConfig/selectOpt', data, 'GET');
// 合同 —— 分页
export const contractPageList = data => fetch('/platform/contractAffairs/getByCompanyId', data, 'GET');
//详情-补录合同查询
export const getContractInfo = id => fetch(`/platform/supplementary/contract/query?id=${id}`, {}, 'GET');
//详情-补录合同-查询
export const getContractPageList = data => fetch('/platform/supplementary/contract/getPage', data, 'GET');
//详情-补录合同-新增
export const addContract = data => fetch('/platform/supplementary/contract/add', data, 'POST');
//详情-补录合同-删除
export const deleteContractInfo = data => fetch('/platform/supplementary/contract/delete', data, 'POST');
export const lineConfigStop = data => fetch('/platform/price/consignorLine/statusSettings', data, 'POST');
// 收入线路价格设置详情
export const lineConfigDetail = data => fetch(`/platform/price/consignorLine/detail/${data} `, {}, 'GET');
// 完善价格
export const completePrice = data => fetch(`/platform/price/consignorLine/perfectPrice${data}`, {}, 'POST');
// 删除
export const lineConDelete = data => fetch(`/platform/price/consignorLine/deleteMore/${data}`, {}, 'POST');
// 新增
export const lineAddConsignorLine = data => fetch('/platform/price/consignorLine/addConsignorLine', data, 'POST');
// 修改
export const lineUpdateConsignorLine = data => fetch('/platform/price/consignorLine/update', data, 'POST');
//修改金额
export const updatePrice = data => fetch(`/platform/price/updatePrice?type=${data.type}&id=${data.id}&price=${data.price}&taxRate=${data.taxRate}`, {}, 'POST');

/**
 * 支出线路价格设置
 *
 */
// 支出线路价格设置分页查询   公路
export const highwayLinePageList = data => fetch('/platform/price/highwayLine/pageList', data, 'POST');
// 公路详情
export const highwayDetail = data => fetch(`/platform/price/highwayLine/detail/${data}`, {}, 'GET');
// 公路启用/停用
export const highwayEnable = data => fetch('/platform/price/highwayLine/updateStatus', data, 'POST');
// 公路删除
export const highwayDelete = data => fetch(`/platform/price/highwayLine/delete/${data}`, {}, 'POST');
//公路供应商
export const highwayLineSelectList = data => fetch('/platform/highwaySupplier/selectList', data, 'GET');

//公路价格 —— 添加
export const highwayLineAdd = data => fetch('/platform/price/highwayLine/addSupplierHighwayLine', data, 'POST');
// 公路价格 —— 修改
export const highwayLineUpdate = data => fetch('/platform/price/highwayLine/updateSupplierHighwayLine', data, 'POST'); // old code ---> addWaterwayLine
// 公路价格 —— 完善价格
export const completeHighPrice = data => fetch(`/platform/price/highwayLine/perfectPrice${data}`, {}, 'POST');
// 支出线路价格设置分页查询   水路
export const waterwayLinePageList = data => fetch('/platform/price/waterwayLine/pageList', data, 'GET');
// 水路详情
export const waterwayDetail = data => fetch(`/platform/price/waterwayLine/detail/${data}`, {}, 'GET');
// 水路 启用/停用
export const waterEnableStop = data => fetch('/platform/price/waterwayLine/updateStatus', data, 'POST');
//水路供应商
export const highwayLineSelectWaterSupplier = data => fetch('/platform/waterSupplier/selectWaterSupplier', data, 'GET');
//水路价格添加
export const waterwayLineAdd = data => fetch('/platform/price/waterwayLine/addWaterwayLine', data, 'POST');
//水路价格修改
export const waterwayLineUpdate = data => fetch('/platform/price/waterwayLine/updateWaterwayLine', data, 'POST');
// 水路价格 —— 完善价格
export const completeWaterPrice = data => fetch('/platform/price/waterwayLine/perfectPrice', data, 'POST');
// 水路删除
export const waterDelete = data => fetch(`/platform/price/waterwayLine/delete/${data}`, {}, 'POST');

/**
 * 金融监管
 *
 */
//收入挂账管理分页
export const financeIncomeList = data => fetch('/platform/finance/income/list', data, 'GET');
//收入挂账管理新增
export const financeIncomeAdd = data => fetch('/platform/finance/income/add', data, 'POST');
//收入挂账管理编辑
export const financeIncomeEdit = data => fetch('/platform/finance/income/edit', data, 'POST');
//收入挂账管理详情A
export const financeIncomeDetail = id => fetch(`/platform/finance/income/detail/${id}`, {}, 'GET');
//收入挂账 提交开票详情
export const incomeSubmitInvoiceDetail = data => fetch('/platform/invoice/manage/incomeSubmitInvoiceDetail', data, 'GET');
//收入挂账 提交开票
export const incomeSubmitInvoiceAdd = data => fetch('/platform/invoice/manage/incomeSubmitInvoiceAdd', data, 'POST');

//支出挂账管理分页
export const financeExpenditureList = data => fetch('/platform/finance/expenditure/list', data, 'GET');
//支出挂账管理新增
export const financeExpenditureAdd = data => fetch('/platform/finance/expenditure/add', data, 'POST');
//支出挂账管理编辑
export const financeExpenditureEdit = data => fetch('/platform/finance/expenditure/edit', data, 'POST');
//支出挂账管理详情
export const financeExpenditureDetail = id => fetch(`/platform/finance/expenditure/detail/${id}`, {}, 'GET');

/**
 * 特殊价格设置
 * @param data
 * @returns {Promise<undefined|*>|*}
 */
// 委托商-特殊结算-分页
export const getSpecialPage = data => fetch('/platform/special/settlement/specialPage', data, 'GET');
//查询历史记录
export const getSpecialHistoryPage = data => fetch('/platform/special/history/list', data, 'POST');
// 供应商-特殊结算-分页
export const getSpecialDeploymentPage = data => fetch('/platform/special/settlement/specialDeploymentPage', data, 'GET');
// 添加结算
export const addSpecialGenerateSettlement = data => fetch('/platform/special/settlement/specialGenerateSettlement', data, 'POST');
export const addSpecialSettlement = data => fetch('/platform/special/history/add', data, 'POST');

// 对账调整-分页-运输
export const getAdjustPageList = data => fetch('/platform/customer/adjust/pageList', data, 'GET');
// 对账调整-分页-库场
export const getSupperAdjustPageList = data => fetch('/platform/customer/supperAdjust/pageList', data, 'GET');
// 对账调整-删除-库场
export const deleteSupperAdjust = data => fetch('/platform/customer/supperAdjust/delete', data, 'POST');
//对账调整-生成折扣费用-库场
export const generateSupperAdjust = data => fetchNew(`/customer/supperAdjust/generate/${data.ids}`, data, 'POST');

// 对账调整-修改-库场
export const updateSupperAdjust = data => fetch('/platform/customer/supperAdjust/update', data, 'POST');
// 对账调整-新增-详情-库场
export const getSupperAdjust = data => fetch('/platform/customer/supperAdjust/getSettlement', data, 'GET');
//对账调整-新增-确认-库场
export const addSupperAdjust = data => fetch('/platform/customer/supperAdjust/add', data, 'POST');
// 添加结算
export const addAdjust = data => fetch('/platform/customer/adjust/addAdjust', data, 'POST');

// 在途信息-船舶跟踪-分页
export const shipTrackingPage = data => fetch('/platform/voyage/tracking/shipTrackingPage', data, 'GET');
// 在途信息-船舶跟踪-实时查询
export const shipTrackingDateInsert = data => fetch('/platform/voyage/tracking/shipTrackingDateInsert', data, 'POST');
// 在途信息-船舶跟踪-修改
export const updateShipTracking = data => fetch('/platform/voyage/tracking/updateShipTracking', data, 'POST');
// 在途信息-船舶跟踪-跟踪
export const shipTracking = data => fetch('/platform/voyage/tracking/shipTracking', data, 'GET');

/**
 * 轮船结算
 * @param data
 * @returns {Promise<undefined|*>|*}
 */
// 轮船结算-江运部分-商品车普价-列表
export const commercialCarPriceList = data => fetch('/platform/riverTransportation/commercialCarPrice/list', data, 'GET');
// 轮船结算-江运部分-商品车普价-新增
export const commercialCarPriceAdd = data => fetch('/platform/riverTransportation/commercialCarPrice/add', data, 'POST');
// 轮船结算-江运部分-商品车普价-停用
export const commercialCarPriceStop = id => fetch(`/platform/riverTransportation/commercialCarPrice/stop/${id}`, {}, 'POST');

// 轮船结算-江运部分-对账明细-列表
export const reconciliationDetailsList = data => fetch('/platform/reconciliationDetails/getReconciliation', data, 'GET');
// 轮船结算-江运部分-对账明细-操作记录
export const reconciliationDetailsOperateRecord = data => fetch('/platform/reconciliationDetails/operateRecord', data, 'GET');
// 轮船结算-江运部分-对账明细-刷新对账
export const reconciliationDetailsRefresh = data => fetch('/platform/reconciliationDetails/flashReconciliation', data, 'POST');
// 轮船结算-江运部分-对账明细-添加备注
export const reconciliationDetailsAdd = data => fetch(`/platform/reconciliationDetails/addMessage/${data.id}/${data.message}`, data, 'POST');
// 轮船结算-江运部分-对账明细-锁定/解锁
export const reconciliationDetailsLock = data => fetch('/platform/reconciliationDetails/lock', data, 'POST');
// 轮船结算-江运部分-对账明细-锁定/解锁
export const updateForFree = data => fetch('/platform/reconciliationDetails/updateForFree', data, 'POST');

// 轮船结算-江运部分-月运量图表分析-列表
export const translationAnalysisList = data => fetch(`/platform/translationAnalysis/getAnalysis?start=${data.start}&end=${data.end}`, {}, 'GET');
// 轮船结算-江运部分-月运量图表分析-列表
export const translationAnalysisEchart = data => fetch(`/platform/translationAnalysis/getAnalysisEchar?start=${data.start}&end=${data.end}`, {}, 'GET');

// 轮船结算-江运部分-江运大报表-列表查询
export const riverTransportationReportPage = data => fetch('/platform/riverTransportationReport/getReport', data, 'GET');
// 轮船结算-江运部分-江运大报表-获取历史数据
export const riverTransportationReportHistoricalData = data => fetch('/platform/riverTransportationReport/getHistoricalData', data, 'GET');
// 轮船结算-江运部分-江运大报表-保存
export const riverTransportationReportSave = data => fetch(`/platform/riverTransportationReport/save/${data.time}`, {}, 'POST');

// 轮船结算-江运部分-商品车计划-列表查询
export const commercialCarPlanPage = data => fetch('/platform/commercial/car/plan/commercialCarPlanPage', data, 'GET');
// 轮船结算-江运部分-商品车计划-获取动态表头以及列表数据
export const brandQuery = data => fetch('/platform/commercial/car/plan/brandQuery', data, 'GET');
// 轮船结算-江运部分-商品车计划-新增
export const commercialCarPlanAdd = data => fetch('/platform/commercial/car/plan/commercialCarPlanAdd', data, 'POST');
// 轮船结算-江运部分-商品车计划-编辑
export const commercialCarPlanUpdate = data => fetch('/platform/commercial/car/plan/commercialCarPlanUpadte', data, 'POST');
// 轮船结算-江运部分-商品车计划-审核
export const commercialCarPlanAudit = data => fetch('/platform/commercial/car/plan/examinePassFail', data, 'POST');
// 轮船结算-江运部分-商品车计划-详情
export const commercialCarPlanDetails = data => fetch(`/platform/commercial/car/plan/details/${data.id}/${data.type}/${data.flag}`, {}, 'GET');
// 轮船结算-江运部分-商品车计划-锁定/解锁
export const lockUnlock = data => fetch('/platform/commercial/car/plan/lockUnlock', data, 'POST');
// 轮船结算-江运部分-商品车计划-删除
export const commercialCarPlanDelete = data => fetch('/platform/commercial/car/plan/batchDelet', data, 'POST');

// 轮船结算-统计部门-年月汇报表-月度-分页
export const monthlySummaryMonthPage = data => fetch('/platform/monthly/summary/month/monthlySummaryMonthPage', data, 'GET');
// 轮船结算-统计部门-年月汇报表-月度-获取下拉数据
export const monthlySummaryMonthQuery = data => fetch('/platform/monthly/summary/month/monthlyQuery', data, 'GET');
// 轮船结算-统计部门-年月汇报表-月度-获取运段
export const monthInformationCollection = data => fetch(`/platform/monthly/summary/month/informationCollection/${data.businessNo}`, {}, 'GET');
// 轮船结算-江运部分-年月汇报表-月度-新增
export const monthlySummaryMonthAdd = data => fetch('/platform/monthly/summary/month/monthlySummaryMonthAdd', data, 'POST');
// 轮船结算-江运部分-年月汇报表-月度-编辑
export const monthlySummaryMonthUpdate = data => fetch('/platform/monthly/summary/month/monthlySummaryMonthUpdate', data, 'POST');
// 轮船结算-江运部分-年月汇报表-月度-刷新
export const monthlySummaryMonthRefresh = data => fetch('/platform/monthly/summary/month/dataRefresh', data, 'POST');
// 轮船结算-统计部门-年月汇报表-月度-详情
export const monthlySummaryMonthDetails = id => fetch(`/platform/monthly/summary/month/details/${id}`, {}, 'GET');
// 轮船结算-江运部分-年月汇报表-月度-删除
export const monthlySummaryMonthDelete = id => fetch(`/platform/monthly/summary/month/monthlySummaryMonthDelete/${id}`, {}, 'POST');
// 轮船结算-江运部分-年月汇报表-月度-提交汇总
export const monthlySummaryMonthSubmit = data => fetch('/platform/monthly/summary/month/submit', data, 'POST');

// 轮船结算-江运部分-年月汇报表-年度-分页
export const summaryYearPage = data => fetch('/platform/monthly/summary/year/summaryYearPage', data, 'GET');
// 轮船结算-江运部分-年月汇报表-月度-提交汇总
export const summaryYearSubmit = data => fetch('/platform/monthly/summary/year/submit', data, 'POST');
// 轮船结算-江运部分-年月汇报表-月度-刷新
export const summaryYearRefreshData = data => fetch('/platform/monthly/summary/year/refreshData', data, 'POST');

// 轮船结算-江运部分-年月汇总表-分页
export const monthlySummaryPage = data => fetch('/platform/monthly/summary/monthlySummaryPage', data, 'GET');
// 轮船结算-江运部分-年月汇总表-修改
export const monthlySummaryUpdate = data => fetch('/platform/monthly/summary/monthlySummaryUpdate', data, 'POST');
// 轮船结算-江运部分-年月汇总表-详情
export const monthlySummaryDetails = id => fetch(`/platform/monthly/summary/details/${id}`, {}, 'GET');
// 轮船结算-江运部分-年月汇总表-表单-详情
export const monthlySummaryDataEcho = id => fetch(`/platform/monthly/summary/dataEcho/${id}`, {}, 'GET');
// 轮船结算-江运部分-年月汇总表-退回
export const monthlySummaryReturnData = data => fetch('/platform/monthly/summary/returnData', data, 'POST');
// 轮船结算-江运部分-年月汇总表-锁定/解锁
export const monthlySummaryLocking = data => fetch('/platform/monthly/summary/monthlySummaryLocking', data, 'POST');

// 轮船结算-统计部门-营业收支级资产净值-分页
export const netOperatingValuePage = data => fetch('/platform/operating/revenue/net/asset/value/netOperatingValuePage', data, 'GET');
// 轮船结算-统计部门-营业收支级资产净值-业务类型查询
export const businessTypeQuery = years => fetch(`/platform/operating/revenue/net/asset/value/businessTypeQuery/${years}`, {}, 'GET');
// 轮船结算-统计部门-营业收支级资产净值-删除
export const netOperatingValueDelete = data => fetch('/platform/operating/revenue/net/asset/value/batchDele', data, 'POST');
// 轮船结算-统计部门-营业收支级资产净值-新增
export const netOperatingValueAdd = data => fetch('/platform/operating/revenue/net/asset/value/netOperatingValueAdd', data, 'POST');
// 轮船结算-统计部门-营业收支级资产净值-修改
export const netOperatingValueUpdate = data => fetch('/platform/operating/revenue/net/asset/value/netOperatingValueUpdate', data, 'POST');
// 轮船结算-统计部门-营业收支级资产净值-详情
export const netOperatingValueDetails = data => fetch(`/platform/operating/revenue/net/asset/value/details/${data.associationId}/${data.type}`, {}, 'GET');
// 轮船结算-统计部门-营业收支级资产净值-锁定/解锁
export const netOperatingValueLockUnlock = data => fetch('/platform/operating/revenue/net/asset/value/lockUnlock', data, 'POST');

// 轮船结算-统计部门-多版本数据差异分析-分页
export const differenceAnalysisPage = data => fetch('/platform/difference/analysis/differenceAnalysisList', data, 'GET');
// 轮船结算-统计部门-多版本数据差异分析-数据刷新
export const dataRefresh = data => fetch('/platform/difference/analysis/dataAggregation', data, 'GET');
// 轮船结算-统计部门-多版本数据差异分析-年月计划-分页
export const getListPage = data => fetchNew('/yearMonthPlan/all/getList', data, 'GET');
// 轮船结算-统计部门-多版本数据差异分析-年月计划/暂估收支
export const differenceAnalysisList = data => fetchNew('/difference/analysis/differenceAnalysisList', data, 'GET');
// 轮船结算-统计部门-多版本数据差异分析-预结算收支
export const getListByMoth = data => fetchNew('/change/review/listByMoth', data, 'POST');
// 轮船结算-统计部门-多版本数据差异分析-预结算4-3差异
export const getDelMonth = data => fetchNew('/change/review/delMonth', data, 'GET');
// 轮船结算-统计部门-多版本数据差异分析-库房及其他和其他费用
export const getOtherByMonth = data => fetchNew('/change/review/getOtherByMonth', data, 'GET');
// 车型格式
export const getCarModelList = () => fetch('/platform/car/model/getCarModelList', {}, 'GET');

// 收款列表
export const consignorReportList = data => fetch('/platform/settlementReport/consignorReportList', data, 'GET');
// 付款列表
export const supplierReportList = data => fetch('/platform/settlementReport/supplierReportList', data, 'GET');
// 设置天使
export const setDays = data => fetch('/platform/settlementReport/setDays', data, 'POST');
// 获取天使
export const getDays = data => fetch('/platform/settlementReport/getDays', data, 'GET');

// 审核管理-财务审核-整车结算-获取人员
export const selectPeople = data => fetch('/platform/finance/audit/selectPeople', data, 'GET');
// 审核管理-财务审核-整车结算-列表
export const vehicleSettlementList = data => fetch('/platform/finance/audit/page', data, 'GET');
// 审核管理-财务审核-整车结算-审核
export const vehicleSettlementAudit = data => fetch('/platform/finance/audit/audit', data, 'POST');
// 审核管理-财务审核-整车结算-获取提交开票信息
export const getInvoiceDetail = id => fetch(`/platform/finance/audit/getInvoiceDetail?id=${id}`, {}, 'GET');
// 审核管理-财务审核-整车结算-驳回/提交开票
export const vehicleSettlementRejectOrSubmit = data => fetch(`/platform/finance/audit/invoice?id=${data.id}&type=${data.type}`, {}, 'POST');
// 审核管理-财务审核-整车结算-打印
export const vehicleSettlementPrint = data => fetch('/platform/finance/audit/print', data, 'GET');


// 新增弹窗
export const getAccount = data => fetch('/platform/customer/adjust/getAccount', data, 'GET');
export const getSettlement = data => fetch('/platform/customer/adjust/getSettlement', data, 'GET');
export const addReconciliationAdjustment = data => fetch('/platform/customer/adjust/add', data, 'POST');
export const updateReconciliationAdjustment = data => fetch('/platform/customer/adjust/update', data, 'POST');
export const deleteReconciliationAdjustment = data => fetch('/platform/customer/adjust/delete', data, 'POST');
export const addGenerateStatementAccount = data => fetch('/platform/customer/account/add', data, 'POST');

export const getReconciliation = data => fetch('/platform/customer/adjust/getReconciliation', data, 'GET');
export const sureSubmitReconciliation = data => fetch(`/platform/customer/adjust/mergeReconciliation/${data.adjustId}/${data.settlementId}`, {}, 'POST');
export const cancelSubmitReconciliation = data => fetch(`/platform/customer/adjust/cancel/${data.id}`, {}, 'POST');

export const generate = data => fetchNew(`/customer/adjust/generate/${data.ids}`, data, 'POST');
/**
 * 年月计划收入价格设置
 *
 */
//查询
export const planConsignorPageList = data => fetchNew('/price/planConsignor/pageList', data, 'POST');
//新增
export const planConsignorAdd = data => fetchNew('/price/planConsignor/add', data, 'POST');
//修改
export const planConsignorUpdate= data => fetchNew('/price/planConsignor/update', data, 'POST');
//删除
export const planConsignorDelete= data => fetchNew(`/price/planConsignor/delete/${data.ids}`, data, 'POST');
//详情
export const planConsignorDetail= data => fetchNew(`/price/planConsignor/detail/${data.id}`, data, 'GET');
/**
 * 年月计划支出价格设置
 *
 */

export const planSupplierAdd = data => fetchNew('/price/planSupplier/add', data, 'POST');

export const planSupplierPageList = data => fetchNew('/price/planSupplier/pageList', data, 'POST');

export const planSupplierUpdate = data => fetchNew('/price/planSupplier/update', data, 'POST');

export const planSupplierDelete = data => fetchNew(`/price/planSupplier/delete/${data.ids}`, data, 'POST');

export const planSupplierDetail = data => fetchNew(`/price/planSupplier/detail/${data.id}`, data, 'GET');
